import { toast } from '@/ui/toast';
import { TOAST_IDS } from '@/ui/toast-ids';

type SelectionLimitToastScope = 'reviews' | 'groups';

const SELECTION_LIMIT_TOAST_IDS: Record<SelectionLimitToastScope, string> = {
    reviews: TOAST_IDS.reviewSelectionLimitReached,
    groups: TOAST_IDS.groupSelectionLimitReached,
};

const createSelectionLimitReachedMessage = (maxSelectedItems: number): string =>
    `Достигнут лимит выбора: ${maxSelectedItems}`;

export const showSelectionLimitReachedToast = ({
    maxSelectedItems,
    scope,
}: {
    maxSelectedItems: number;
    scope: SelectionLimitToastScope;
}): void => {
    toast.warning(createSelectionLimitReachedMessage(maxSelectedItems), {
        toastId: SELECTION_LIMIT_TOAST_IDS[scope],
    });
};
